import { apiClient } from "@/lib/api";
import { fetchAllPages } from "@/lib/fetchAllPages";
import type { ReaderPreset, ReaderPresetCreate } from "@/types";

/** Backend cap: GET /reader-presets `limit` le=200. */
const READER_PRESETS_PAGE_SIZE = 200;

export const readerPresetKeys = {
  all: ["reader-presets"] as const,
  lists: () => [...readerPresetKeys.all, "list"] as const,
};

export const readerPresetService = {
  getAll: (): Promise<ReaderPreset[]> =>
    fetchAllPages(async (page) => {
      const response = await apiClient.get<ReaderPreset[]>("/reader-presets", {
        params: page,
      });
      return response.data;
    }, READER_PRESETS_PAGE_SIZE),

  create: async (data: ReaderPresetCreate): Promise<ReaderPreset> => {
    const response = await apiClient.post<ReaderPreset>(
      "/reader-presets",
      data,
    );
    return response.data;
  },

  update: async (
    presetId: string,
    data: ReaderPresetCreate,
  ): Promise<ReaderPreset> => {
    const response = await apiClient.put<ReaderPreset>(
      `/reader-presets/${presetId}`,
      data,
    );
    return response.data;
  },

  delete: async (presetId: string): Promise<void> => {
    await apiClient.delete(`/reader-presets/${presetId}`);
  },
};
